import {importLibrary, setOptions} from "@googlemaps/js-api-loader";

let loadPromise: Promise<void> | null = null;

export function loadGoogleMaps(): Promise<void> {
	if (loadPromise == null) {
		loadPromise = doLoadGoogleMaps().catch(error => {
			loadPromise = null;
			throw error;
		});
	}

	return loadPromise;
}

async function doLoadGoogleMaps(): Promise<void> {
	const apiKey = document.querySelector<HTMLMetaElement>("meta[name='google-maps-key']")?.content?.trim();
	const mapId = document.querySelector<HTMLMetaElement>("meta[name='google-maps-id']")?.content?.trim();

	if (!apiKey) {
		throw new Error("Google Maps API key not found in meta tag google-maps-key");
	}

	setOptions({
		key: apiKey,
		...(mapId ? {mapIds: [mapId]} : {}),
		v: "weekly",
		language: globals.language,
	});

	await Promise.all<unknown>([
		importLibrary("maps"),
		importLibrary("marker"),
		importLibrary("places"),
		importLibrary("geocoding"),
	]);
}
